import React, { useEffect, useState } from "react";
import API from '../Services/Banner';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UploadBanner = () => {
    const [bannerList, setBannerList] = useState([]);
    const [logo, setLogo] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [type, setType] = useState("");
    useEffect(() => {
        bindBanner()
    }, [currentPage])


    const bindBanner = async () => {
        try {
            const response = await API.UploadBannerData();
            if (response.status === 200) {
                setBannerList(response.data.data);
            } else if (response.status === 400) {
                toast.error("Bad request. Please check your input data.");
            } else if (response.status === 403) {
                toast.error("Access forbidden. You don't have permission to access this resource.");
            } else if (response.status === 500) {
                toast.error("Internal server error. Please try again later.");
            } else {
                toast.error("Unexpected error occurred. Please try again.");
            }
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 400) {
                    toast.error("Bad request. Please check your input data.");
                } else if (status === 403) {
                    window.location.replace("/Login")
                }
                else if (status === 500) {
                    toast.error("Internal server error. Please try again later.");
                } else {
                    toast.error(`Unexpected error: ${status}`);
                }
                console.error("API Error Response:", error.response);
            } else if (error.request) {
                // No response from the server
                toast.error("No response from the server. Please check your network connection.");
                console.error("Network Error:", error.request);
            } else {

                toast.error("An unexpected error occurred.");
                console.error("Unexpected Error:", error.message);
            }
        }
    };


    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
        const maxSize = 5 * 1024 * 1024;
        if (!allowedFormats.includes(file.type)) {
            toast.error("Only JPG, PNG, and GIF formats are allowed.");
            setLogo(null);
            return;
        }
        if (file.size > maxSize) {
            toast.error("File size must be 5MB or smaller.");
            setLogo(null);
            return;
        }
        setLogo(file);
        setLogoPreview(URL.createObjectURL(file));
    };

    const handleUploadBanner = async () => {
        if (!logo) {
            toast.error("Please upload a valid image.");
            return;
        }
        const formData = new FormData();
        formData.append("banner", logo);
        try {
            const response = await API.Upload_Photo(formData);
            if (response.status === 200) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data?.message || "Unexpected response from the server.");
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data?.message || `Error: ${error.response.status}`);
                console.error("Server Error:", error.response);
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login")
            }
            else if (error.request) {
                toast.error("No response from the server. Please try again.");
                console.error("Network Error:", error.request);
            } else {
                toast.error("An unexpected error occurred.");
                console.error("Unexpected Error:", error.message);
            }
        }
    };


    const handleSubmit = async () => {
        if (isEditing) {
        } else {
            await handleUploadBanner();
        }
    };

    const handleCancel = () => {
        setLogo(null);
        setLogoPreview(null);
        setIsEditing(false);
    };


    const totalPages = Math.ceil(bannerList.length / perPage);
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    const currentData = bannerList.slice(startIndex, endIndex);
    // console.log("current data...", currentData.length)

    const handlePageChange = (page) => {
        // console.log("page change..", page)
        setCurrentPage(page);
    };


    const handleGetLogo = (logo) => {
        // console.log("logo data...", logo)
        setLogo(logo)
    }

    return (
        <div className="col-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">Upload Banner</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>
                                    Type <span style={{ color: "red" }}>*</span>
                                </label>
                                <select
                                    className="form-select"
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >

                                    <option value="">Select Type</option>
                                    <option value="Customer Portal">Customer Portal</option>
                                    <option value="POS">POS</option>
                                </select>
                                {/* {error?.type && <span className="text-danger" style={{ fontSize: "12px" }}>{error.type}</span>} */}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="txtimage">Upload Logo</label>
                                <input
                                    accept="image/png, image/gif, image/jpeg"
                                    type="file"
                                    className="form-control"
                                    id="txtimage"
                                    onChange={handleLogoChange}
                                />
                              
                            </div>
                        </div>
                        <div className="col-md-4">
                              {logoPreview && (
                                    <div className="mt-2">
                                        <img src={logoPreview || 'No Image Available'} alt="Logo Preview" style={{ width: '100px', height: 'auto' }} />
                                    </div>
                                )}
                        </div>
                    </div>


                    <div className="mt-3">
                        <button onClick={handleSubmit} className="btn btn-primary">
                            {isEditing ? "Update" : "Submit"}
                        </button>
                        <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                    </div>
                </div>
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Uploaded Banners</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th>SrNo</th>
                                            <th>Status</th>
                                            <th>Logo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                {/* <button className="btn btn-success btn-sm"
                                                    onClick={() => handleGetData(item.id)}
                                                >Edit</button>{' '} */}
                                                {/* <button
                                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                    onClick={() => changeStatus(item.id, item.is_active)}>
                                                    {item.is_active ? "Deactivate" : "Activate"}
                                                </button> */}
                                                <td>{item.is_active ? "Active" : "De-Activated"}</td>
                                                {/* <button className="btn btn-sm">Active</button> */}
                                                {/* <td><img src={item.image_url} style={{height:"100px",width:"100px"}}></img></td> */}
                                                <td>
                                                    <button onClick={() => handleGetLogo(item.image_url)}
                                                        className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo">
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}>
                                                Previous
                                            </button>
                                        </li>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <li
                                                key={index + 1}
                                                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(index + 1)}>
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`} >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModallogo">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Logo</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row my-3" style={{ justifyContent: "center" }}>
                                    <img src={logo || 'No Image Available'} alt="Logo" style={{ "width": "200px", "height": "150px", }} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default UploadBanner;
